export const WORKSPACES_LOADED = "workspaces/workspacesLoaded"
export const WORKSPACES_ADDED = "workspaces/workspacesAdded"
export const WORKSPACE_UPDATED = "workspaces/workspaceUpdated"
export const WORKSPACE_DELETED = "workspaces/workspaceDeleted"